import { Button, Stack, Textarea } from '@mantine/core';
import { useField } from '@mantine/form';
import { Right } from 'components/Right';
import { tKeys, useTranslation } from 'locales';
import HTML from 'shared/components/HTML/HTML';
import { useSendClientFeedback } from 'shared/hooks/use-send-slack-notification';

type FeedbackFormProps = {
  featureName: string;
  description?: string;
  label?: string;
  isFillingHeight?: boolean;
  onSent?: VoidFunction;
};

export const FeedbackForm = ({
  description,
  featureName,
  label,
  isFillingHeight = true,
  onSent,
}: FeedbackFormProps) => {
  const { t } = useTranslation();
  const feedback = useField({ initialValue: '' });
  const { sendClientFeedback, isSendClientFeedbackLoading } = useSendClientFeedback();

  const handleSendFeedback = () =>
    sendClientFeedback(
      { feature: featureName, request: feedback.getValue() },
      { onSuccess: onSent },
    );

  return (
    <Stack h={isFillingHeight ? '100%' : undefined}>
      <Textarea
        rows={5}
        mih={isFillingHeight ? '100%' : undefined}
        label={label ?? t(tKeys.FEEDBACK.BUTTON)}
        description={<HTML html={description} />}
        disabled={isSendClientFeedbackLoading}
        placeholder={t(tKeys.FEEDBACK.PLACEHOLDER)}
        resize="both"
        {...feedback.getInputProps()}
      />
      <Right>
        <Button
          disabled={feedback.getValue().trim() === ''}
          size="compact-sm"
          variant="light"
          loading={isSendClientFeedbackLoading}
          onClick={handleSendFeedback}
        >
          {t(tKeys.SUBMIT)}
        </Button>
      </Right>
    </Stack>
  );
};
